const CustomDatapicker = {
  custom: 'Custom range',
  custom_medium: 'Custom',
  shortcuts: {
    text: {
      'week': 'Week',
      '1month': '1 month',
      '3months': '3 months'
    },
    text_short: {
      'week': '1w',
      '1month': '1m',
      '3months': '3m'
    }
  },
  tooltips: {
    'custom': 'Custom range',
    'week': 'Week',
    '1month': '1 month',
    '3months': '3 months'
  },
};

export default CustomDatapicker;
